module.exports = __webpack_public_path__ + "static/media/hotelPipa2.eb4e8d13.jpg";